import PropTypes from 'prop-types';

import DiscountCodeApplied from './DiscountCodeApplied';
import DiscountCodeInput from './DiscountCodeInput';
import DiscountCodeShowInput from './DiscountCodeShowInput';

const DiscountCodeStrategy = ({ discountAppliedView, isInputInView }) => {
  if (discountAppliedView) {
    return <DiscountCodeApplied />;
  }

  if (isInputInView) {
    return <DiscountCodeInput />;
  }

  return <DiscountCodeShowInput />;
};

DiscountCodeStrategy.propTypes = {
  discountAppliedView: PropTypes.bool.isRequired,
  isInputInView: PropTypes.bool.isRequired,
};

export default DiscountCodeStrategy;
